/** @file jointShown: whether a joint is marked in the viewport (not hidden; isolate: only the selection). */
import { POSE_LAYOUT as L } from '@zilo/pose3d-pose/layout/poseLayout';
import type { MarksInput } from './jointMarks';

/** Node `i` is shown when its hidden flag is clear and, while isolate is on, its name is selected. */
export function jointShown(m: MarksInput, i: number): boolean {
  if (((m.pose[i * L.stride + L.flags] ?? 0) & 1) !== 0) return false;
  return !m.isolate || m.selected.includes(m.names[i] ?? '');
}
